import { render, staticRenderFns } from "./DataViewSidebar.vue?vue&type=template&id=1a41ffea&scoped=true"
import script from "./DataViewSidebar.vue?vue&type=script&lang=js"
export * from "./DataViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebar.vue?vue&type=style&index=0&id=1a41ffea&prod&lang=scss&scoped=true"
import style1 from "./DataViewSidebar.vue?vue&type=style&index=1&id=1a41ffea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41ffea",
  null
  
)

export default component.exports